import React from 'react';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';

class Login extends React.Component {

    constructor(props) {
        super(props);

        this.logIn = this.logIn.bind(this);
    }

    logIn(e) {
        e.preventDefault();
        this.props.logIn(this.email, this.password);
    }

    render() {
        return (
            <div className="Login">
                <h1>{this.props.headline}</h1>
                {this.props.description && <p>{this.props.description}</p>}
                <Form onSubmit={this.logIn}>
                    <FormGroup>
                        <Label>Email Address</Label>
                        <Input type="email" onChange={ (e) => { this.email = e.target.value; }} />
                    </FormGroup>
                    <FormGroup>
                        <Label>Password</Label>
                        <Input type="password" onChange={ (e) => { this.password = e.target.value; }} />
                    </FormGroup>
                    <Button color="primary" type="submit">Log in</Button>
                </Form>
            </div>
        )
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Login.js